/* LADA — product-zoom.js (prohlížeč fotografií bez vlastního zoomu)
   Používá ho detail kusu Travel setu (sections/travel-set-pieces.liquid). Otevírá se přes [data-lb-open="id"],
   ukáže fotografii celou (1×), popisek a čítač; listování swipem v 1×, šipkami a tlačítky; Escape zavře.
   Žádný pinch/dvojtap/kolečko: zvětšení fotografie je na mobilu běžné dvouprsté zvětšení celé stránky
   (rozhodnutí Mariana 29. 10. 2026). Dialog otevírá a zavírá theme.js (data-modal): focus trap, zámek scrollu,
   návrat fokusu. */
(function () {
  'use strict';
  const dlg = document.querySelector('[data-lightbox]');
  if (!dlg) return;
  const stage = dlg.querySelector('[data-lb-stage]');
  const img = dlg.querySelector('[data-lb-img]');
  const status = dlg.querySelector('[data-lb-status]');
  const counter = dlg.querySelector('[data-lb-count]');
  const captionEl = dlg.querySelector('[data-lb-caption]');
  const items = Array.from(dlg.querySelectorAll('[data-lb-list] li')).map(li => ({
    id: String(li.dataset.mediaId), src: li.dataset.src, alt: li.dataset.alt || '', preview: li.dataset.preview || '', caption: li.dataset.caption || '', text: li.dataset.text || ''
  }));
  if (!items.length) return;
  const SWIPE = 40;
  let idx = 0, loadToken = 0;
  const isOpen = () => dlg.classList.contains('is-open');

  function setStatus(text, retry) {
    if (!status) return;
    status.textContent = '';
    if (!text) return;
    status.append(text);
    if (retry) { const b = document.createElement('button'); b.type = 'button'; b.className = 'lb-retry'; b.textContent = status.dataset.retry || 'Retry'; b.addEventListener('click', () => show(idx)); status.append(' ', b); }
  }
  function show(i) {
    idx = (i + items.length) % items.length;
    const item = items[idx];
    const token = ++loadToken;
    if (counter && counter.dataset.label) { counter.textContent = counter.dataset.label.replace('__i__', idx + 1).replace('__n__', items.length); counter.hidden = items.length < 2; }
    if (captionEl) { captionEl.textContent = ''; if (item.caption) { const b = document.createElement('strong'); b.textContent = item.caption; captionEl.append(b); } if (item.text) captionEl.append(item.caption ? ' ' : '', item.text); captionEl.hidden = !(item.caption || item.text); }
    img.alt = item.alt;
    img.style.transform = '';
    if (item.preview) { img.src = item.preview; img.hidden = false; } else img.hidden = true;
    setStatus(status ? status.dataset.loading : '');
    const probe = new Image();
    probe.onload = function () { if (token !== loadToken) return; img.src = probe.src; img.hidden = false; setStatus(''); };
    probe.onerror = function () { if (token !== loadToken) return; setStatus(status ? status.dataset.error : '', true); if (!item.preview) img.hidden = true; };
    probe.src = item.src;
  }
  function step(d) { if (items.length < 2) return; show(idx + d); }
  function indexOfMedia(id) { const i = items.findIndex(x => x.id === String(id)); return i < 0 ? 0 : i; }
  function open(mediaId, opener) {
    if (!window.ladaDialog || isOpen()) return;
    window.ladaDialog.open(dlg, opener || null);
    show(indexOfMedia(mediaId));
  }
  dlg.addEventListener('lada:dialog-close', () => { loadToken++; });
  window.ladaLightbox = { open: open, isOpen: isOpen };
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-lb-open]');
    if (btn) { e.preventDefault(); open(btn.dataset.lbOpen || null, btn); }
  });
  dlg.addEventListener('click', e => {
    if (e.target.closest('[data-lb-prev]')) step(-1);
    else if (e.target.closest('[data-lb-next]')) step(1);
  });
  dlg.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
  });
  /* swipe mezi snímky (jeden prst); dva prsty = nativní zvětšení stránky, do toho se nezasahuje */
  let sx = null, sy = null, multi = false;
  stage.addEventListener('touchstart', e => { if (e.touches.length > 1) { multi = true; sx = null; return; } multi = false; sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchend', e => {
    if (multi || sx === null || !e.changedTouches.length) { sx = null; return; }
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
    if (Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy) * 1.2) step(dx < 0 ? 1 : -1);
  }, { passive: true });
})();
